import React, {Component} from 'react'
import {createStructuredSelector} from "reselect"
import {connect} from "react-redux"
import styled from "styled-components"
import {
  DESKTOP_BREAKPOINT,
} from "manager/views/components/Settlement/constants"
import BackLink from "manager/views/components/Settlement/Common/BackLink"
import poweredByQualia from "manager/../images/powered-by-qualia.svg"
import StyledButton from "common/views/components/StyledButton"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard"

const MoreInfoContainer = styled(SettlementCard)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  margin-top: 0px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    margin-top: 44px;
  }
`

const MoreInfoTitle = styled.div`
  color: #4A4A4A;
  margin-top: 14px;
  padding: 10px 40px;
  font-size: 22px;
  font-weight: bold;
  line-height: 28px;
  text-align: center;
`

const MoreInfoBodyItem = styled.div`
  color: #4A4A4A;
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  padding: 10px 30px;
  align-self: center;
  @media screen and ${DESKTOP_BREAKPOINT} {
    padding: 20px 45px;
  }
`

const Button = styled(StyledButton)`
  height: 41px;
  width: 108px;
  align-self: center;
  margin-top: 10px;
`

const PoweredByImage = styled.div`
  background-image: url(${poweredByQualia});
  height: 30px;
  width: 94px;
  margin-top: 20px;
  align-self: center;
`

const QualiaImage = styled.img`
  height: 136px;
  width: 230px;
  align-self: center;
  margin: 15px;
`


class MoreInfo extends Component {
  hideMoreInfo = () => {
    this.props.showMoreInfo(false)
  }

  render() {
    return (
      <SettlementMaxWidth>
        {this.props.isMobile && <BackLink onClick={this.hideMoreInfo} /> }
        <MoreInfoContainer paddingLeftRight='20px'>
          <MoreInfoTitle>Bringing Transparency to Title & Escrow</MoreInfoTitle>
          <QualiaImage src="https://s3.amazonaws.com/opcity-email-assets/shared/qualia-illo.png"/>
          <MoreInfoBodyItem>Want to stand out from the competition? Take advantage of the option to order digital-powered title services through realtor.com®.</MoreInfoBodyItem>
          <MoreInfoBodyItem>Enjoy confidence on the way to close with real-time progress tracking, automated tasks, secure document sharing, and more digital closing tools powered by Qualia.</MoreInfoBodyItem>
          <Button primary oldColorPalette={true} largerFont={true} onClick={this.hideMoreInfo}>Got it!</Button>
          <PoweredByImage/>
          <MoreInfoBodyItem style={{fontSize:'13px', color:'#8C8C8C'}}>Realtor.com® and Qualia do not endorse specific title & escrow providers. If you choose, you can work with any title & escrow provider outside of the platform.</MoreInfoBodyItem>
        </MoreInfoContainer>
      </SettlementMaxWidth>
    )
  }

}

const selector = createStructuredSelector({
})

export default connect(selector)(MoreInfo)
